import { Question } from '../../../interfaces/questions.interface';

const generateDummyQuestion = (category: string): Omit<Question, '_id' | 'chapter'> => {
  const topics = {
    'Basic': ['Road Signs', 'Traffic Rules', 'Right of Way'],
    'Advanced': ['Highway Driving', 'Night Driving', 'Weather Conditions'],
    'Professional': ['Load Security', 'Vehicle Inspection', 'Documentation'],
    'Safety': ['Emergency Procedures', 'Accident Prevention', 'First Aid']
  };

  const getRandomTopic = () => {
    const categoryTopics = topics[category as keyof typeof topics] || topics['Basic'];
    return categoryTopics[Math.floor(Math.random() * categoryTopics.length)];
  };

  const topic = getRandomTopic();
  const questionNumber = Math.floor(Math.random() * 100000);

  return {
    questionAnnouncement: `${topic} Question ${questionNumber}: What is the correct procedure when ${topic.toLowerCase()} in challenging conditions?`,
    category,
    answerA: `Follow standard ${topic.toLowerCase()} protocol`,
    answerB: `Implement advanced ${topic.toLowerCase()} techniques`,
    answerC: `Consult the ${topic.toLowerCase()} manual`,
    answerD: `Contact supervisor for ${topic.toLowerCase()} guidance`,
    correctAnswers: ['A', 'B'].slice(0, Math.floor(Math.random() * 2) + 1), // Randomly select 1 or 2 correct answers
    fileName: Math.random() > 0.5 ? `${topic.toLowerCase().replace(/\s+/g, '-')}-${questionNumber}.jpg` : undefined
  };
};

export const getInitialValues = (category: string): Omit<Question, '_id' | 'chapter'> => {
  return process.env.NODE_ENV === 'development'
    ? generateDummyQuestion(category)
    : {
        questionAnnouncement: '',
        category,
        answerA: '',
        answerB: '',
        answerC: '',
        answerD: '',
        correctAnswers: [],
      };
};
